import { useEffect, useState } from 'react';

export const useResize = () => {
    const [{ width, height }, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });

    useEffect(() => {
        const handleResize = (event: UIEvent) => {
            setSize({
                width: (event?.target as Window).innerWidth,
                height: (event?.target as Window).innerHeight
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { width, height };
};
